import { createFileRoute } from '@tanstack/react-router'
import { Trans } from '@lingui/react/macro'
import { getBrandConfig } from '@/config/config'
import { AccountLockedHeader } from '@/features/account-locked/account-locked-header'
import { AccountLockedLinks } from '@/features/account-locked/account-locked-links'
import { Link } from '@vgw/multibrand-fe-link'

export const Route = createFileRoute(
  '/_app/account-locked/restricted-jurisdiction',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { name: brandName, pamLegalDocumentsUrl } = getBrandConfig()

  return (
    <>
      <AccountLockedHeader
        heading={<Trans>Location restricted</Trans>}
        description={
          <>
            <p className="mb-3">
              <Trans>
                {brandName} is not currently available to play in your location.
                <Link
                  size="md"
                  target="_blank"
                  rel="noopener"
                  href={`${pamLegalDocumentsUrl}/terms-and-conditions`}
                  className="px-1.5"
                  weight="regular"
                >
                  Check our Terms & Conditions
                </Link>
                for permitted jurisdictions.
              </Trans>
            </p>
            <p>
              <Trans>
                If you believe you should have access, please provide valid
                proof of address via our Account Verification tools.
              </Trans>
            </p>
          </>
        }
      />
      <AccountLockedLinks accountVerification />
    </>
  )
}
